import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { fetchHumidityData } from "./utils/api"
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import DeviceToggle from './components/DeviceToggle.tsx';


mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;


const monument = [74.3587, 31.5204];
const lahoreBBox = [74.05, 31.3, 74.5, 31.65]; // [minLng, minLat, maxLng, maxLat]
const offlineColor = "rgba(128, 128, 128, 0.5)";
const onlineColor = "rgba(117, 207, 240,0.5)";
const App = () => { 
  const mapContainerRef = useRef();
  const mapRef = useRef();
  const [humidityData, setHumidityData] = useState([]);
  const [showOnline, setShowOnline] = useState(true);
  const isOnline = useRef(true);
  const intervalId = useRef(null);

  const handleToggle = () => {
  setShowOnline((prev) => {
    const newState = !prev;
    
    isOnline.current = newState;
   updateHumidityLayer();
    
    return newState;
  });
};


const updateHumidityLayer = async () => {
      const humidityData = await fetchHumidityData(`${process.env.REACT_APP_BASE_URL}/humidity-data?show_online=${isOnline.current ? 1 : 0 }`);
      const data = humidityData?.data ?? { type: 'FeatureCollection', features: [] };
      setHumidityData(Array.isArray(data.features) ? data.features : []);
      console.log("Fetched Humidity Data:", data);
      if (!mapRef.current.getSource('m5-data')) {
        mapRef.current.addSource('m5-data', {
          type: 'geojson',
          data: data
        });
      } else {
        mapRef.current.getSource('m5-data').setData(data);
      }
      if (mapRef.current?.getLayer('m5-circle-layer')) {
      mapRef.current.setPaintProperty(
        'm5-circle-layer',
        'circle-color',
        isOnline.current ? onlineColor : offlineColor
      );
    }
    };
  useEffect(() => {
      

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: monument,
      zoom: 11,
      minZoom: 1
    });
    const popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false
      });

    // const nav = new mapboxgl.NavigationControl();
    // mapRef.current.addControl(nav, 'top-right');

    mapRef.current.on('load', async () => {
      await mapRef.current.loadImage('icons8-iot-64.png', async (error, image) => {
        if (error) {
          console.log(error);
        }
        // Add the image to the map style.
        if (!mapRef.current.hasImage('iot-icon'))
          await mapRef.current.addImage('iot-icon', image);
      });
      

    // Initial call
    await updateHumidityLayer();

      
      await mapRef.current.addLayer({
        id: 'm5-circle-layer',
        type: 'circle',
        source: 'm5-data',
        paint: {
          "circle-color": onlineColor,
          'circle-stroke-color': 'transparent',
          'circle-stroke-width': 20,
          'circle-radius': 50,
        },
      });
         

      const geocoder = new MapboxGeocoder({
                accessToken: mapboxgl.accessToken,
                mapboxgl: mapboxgl,
                placeholder: 'Search location',
                bbox: lahoreBBox,
                proximity: { longitude: 74.3436, latitude: 31.5204 }, // Lahore center
                  limit: 5,
              });
      mapRef.current.addControl(geocoder, 'top-right');
      await mapRef.current.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

      await mapRef.current.addLayer({
        id: 'm5-data-layer',
        type: 'symbol',
        source: 'm5-data',
        paint: {
          "text-color": "#000000",
        },
        layout: {
          'icon-image': 'iot-icon',
          'icon-size': 0.4,
          'text-field': `Temp: {temperature} °C \n Humidity: {humidity}% \n Date: {date}\n Time: {time}`,
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 10,
          'icon-anchor': 'bottom',
          'text-anchor': 'top',
          "text-justify": "left",
          'text-offset': [0, -1.5],
          'icon-offset': [0, -45],
        },
      });
    intervalId.current = setInterval(updateHumidityLayer, 5000);

    })

    mapRef.current.on('mouseenter', 'm5-data-layer', (e) => {
      mapRef.current.getCanvas().style.cursor = 'pointer';
      const coordinates = e.features[0].geometry.coordinates.slice();
    const { temperature, humidity, latitude, longitude, counter , mac,label} = e.features[0].properties;

      const html = `
        <div style="font-size:12px; line-height:1.5;">
          <strong>Device Label:</strong> ${label}<br/>
          <strong>MAC Address:</strong> ${mac}<br/>
          <strong>Latitude:</strong> ${latitude}<br/>
          <strong>Longitude:</strong> ${longitude}<br/>
          <strong>Counter:</strong> ${counter}<br/>
         
          
        </div>
      `;

      popup.setLngLat(coordinates).setHTML(html).addTo(mapRef.current);
    });
    mapRef.current.on('mouseleave', 'm5-data-layer', () => {
      mapRef.current.getCanvas().style.cursor = '';
      popup.remove();
    });

    mapRef.current.on('click', 'm5-data-layer', (e) => {
      const zoom = mapRef?.current?.getZoom();
      if (zoom < 15) {
        mapRef.current.flyTo({
          center: e?.features[0]?.geometry.coordinates,
          zoom: 15,
        });
      } else {
        mapRef.current.flyTo({
          center: e?.features[0]?.geometry.coordinates,
        });
      }
    });

    return () => {
    clearIntervals()
    mapRef.current.remove();
    };

  }, []);
 
  const clearIntervals = () => {
    if (intervalId.current) clearInterval(intervalId.current);
  }
  return (
    <>
      <div ref={mapContainerRef} style={{ height: '100vh', width: "100vw" }} />
      {/* Toggle Button */}
    
      <DeviceToggle totalDevices={humidityData?.length ?? 0} handleToggle={handleToggle} showOnline={showOnline} />
    
    </>
  );
};

export default App;

